import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { constants } from "redux/recognitions/actions";
import { commonConstants } from "redux/common/actions";

const { REQUEST } = commonConstants;

const { FETCH_RECOGNITIONS_LIST } = constants;

export const useRecognitions = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchRecognitions = () => {
      dispatch({
        type: FETCH_RECOGNITIONS_LIST + REQUEST,
      });
    };
    fetchRecognitions();
  }, []);
};
